import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ContentBoxQueue,
  StyledInsert,
  StyledInsertBtn,
  StyledInsertContent,
  StyledInsertServicesText,
  StyledInsertText,
  StyledInsertTitle
} from '../KindergartenServicesStyle';
import './../KindergartenServicesTranslate';
import { Content } from '../../../components/ThemeProvider/ThemeStyle';
import kindergartenServicesBg from '../../../_assets/images/kindergartenServicesBg.png';
import { kindergarten_services_insert } from '../KindergartenServicesItems';
import InsertBtn from './InsertBtn';
import { Box } from '@material-ui/core';

function KindergartenInsert({ contentWidth }) {
  const { t } = useTranslation();

  return (
    <StyledInsert>
      <img src={kindergartenServicesBg} alt="" />
      <StyledInsertContent>
        <Content contentWidth={contentWidth}>
          <StyledInsertTitle children={t('kindergarten_insert_title')} />
        </Content>
        <Content contentWidth={contentWidth}>
          <StyledInsertText children={t('kindergarten_insert_text')} />
        </Content>
        <Content contentWidth={contentWidth}>
          <Box>
            <StyledInsertServicesText>в области Жетісу</StyledInsertServicesText>
            <StyledInsertBtn>
              <InsertBtn metadata={kindergarten_services_insert.doc_queued_ddo_short} />
            </StyledInsertBtn>
          </Box>
          <Box>
            <StyledInsertServicesText>в г. Талдыкорган</StyledInsertServicesText>
            <StyledInsertBtn>
              <InsertBtn metadata={kindergarten_services_insert.voucher_queue_short} />
            </StyledInsertBtn>
          </Box>
        </Content>
        <Content contentWidth={contentWidth}>
          <ContentBoxQueue>
            <StyledInsertBtn style={{ marginTop: '20px' }}>
              <InsertBtn metadata={kindergarten_services_insert.check_queue_number} />
            </StyledInsertBtn>
          </ContentBoxQueue>
        </Content>
      </StyledInsertContent>
    </StyledInsert>
  );
}

export default KindergartenInsert;
